import React from 'react';

import {BusinessHoursContainer} from '../../../../../analytics/components/businessHours/businessHoursContainer';

/*
 * Props.
 */

interface SlaEditorBusinessHoursProps {
  namespace: string;
}

/*
 * Component.
 */

export const SlaEditorBusinessHours: React.FC<SlaEditorBusinessHoursProps> = (props) => {
  const {namespace} = props;

  return <BusinessHoursContainer namespace={namespace} />;
};
